var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "upload-container"
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保告知书回传")))])]), _vm.templateList.length === 0 ? _c("div", [_c("div", {
    staticClass: "empty-container"
  }, [_c("a-icon", {
    attrs: {
      type: "inbox"
    }
  }), _c("div", {
    staticClass: "empty-text"
  }, [_vm._v(_vm._s(_vm.$t("暂无模板")))])], 1)]) : _c("a-form-model", {
    ref: "uploadForm",
    attrs: {
      model: _vm.formData,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, _vm._l(_vm.templateList, function (item) {
    return _c("a-form-model-item", {
      key: item.noticeTemplateId,
      attrs: {
        label: item.noticeTemplateName
      }
    }, [_c("div", {
      staticClass: "upload-item"
    }, [_c("a-upload", {
      staticStyle: {
        width: "170px"
      },
      attrs: {
        action: _vm.uploadAction,
        "list-type": "picture-card",
        "file-list": item.fileList,
        "before-upload": file => _vm.beforeUpload(file, item.noticeTemplateId),
        accept: ".doc,.docx",
        headers: _vm.headers,
        data: {
          module: "insuranceNotice"
        }
      },
      on: {
        change: info => _vm.handleChange(info, item)
      }
    }, [item.fileList.length < 1 ? _c("div", {
      staticClass: "upload-trigger"
    }, [_c("a-icon", {
      attrs: {
        type: "plus"
      }
    }), _c("div", {
      staticClass: "upload-text"
    }, [_vm._v("上传文件")])], 1) : _vm._e()]), _c("div", {
      staticClass: "download-btn"
    }, [_c("a-button", {
      attrs: {
        type: "primary"
      },
      on: {
        click: function ($event) {
          return _vm.downloadTemplate(item);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: "download"
      }
    }), _vm._v(" 下载模板 ")], 1)], 1)], 1)]);
  }), 1), _vm.templateList.length > 0 ? _c("div", {
    staticClass: "submit-area"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };